




































































































































































































































































































































































































































































































































































































































import { Component, Watch, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { ModalTextArea } from '@/components/modals/ModalTextArea'
import { BibliographyTagInput } from '@/components/organisms/BibliographyTagInput'
import {
  Alert,
  AlertMessage,
  bibliographyContentApi,
  bibliographyRealApi,
  bibliographySetApi,
  BibliographyTagRegisterData,
  ErrorMessage,
  FirstMarcLabel,
  Keyword,
  MarcLabel,
  marcLabelApi,
  MarcTag,
  separateApi,
  SeparateKeyword
} from '@/api'
import { cloneDeep, countBy } from 'lodash'
import {
  AlertCodeALC00002,
  AlertCodeCLT00042,
  AuthorityItem,
  BibliographyClass,
  SearchType,
  TagAuthorityAuthorDisplay,
  TagAuthorityAuthorKana,
  TagAuthorityCompleteWorksDisplay,
  TagAuthorityCompleteWorksKana,
  TagAuthorityPublisherDisplay,
  TagAuthorityPublisherKana,
  TagAuthoritySeriesDisplay,
  TagAuthoritySeriesKana,
  TagAuthoritySubjectDisplay,
  TagAuthoritySubjectKana
} from '@/types'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import {
  alertStore,
  dataStore,
  modalBibliographyTagDataEditStore,
  modalErrorStore
} from '@/utils/store-accessor'
import { AlertFactory } from '@/factory'

export interface MarcTagInput {
  tag: string
  marcTag: string
  labelName: string
  repeat: boolean
  fieldType: string
  maxLength: number
  systemCodeKey: string
  no: string
  data: string
  errorMessage: string
  isMarcTypeField?: boolean
  isAuthorityNameField?: boolean
  isAuthorityKanaField?: boolean
  authorityNo?: string
}

export interface MarcTagInputData {
  default: MarcTagInput
  marcNo?: MarcTagInput
  authorityName?: MarcTagInput
  authorityKana?: MarcTagInput
  authorityRole?: MarcTagInput
}

export interface MarcLabelInput {
  labelName: string
  repeat: boolean
  tags: MarcTagInputData[]
  no: string
  tagGroup: string
  tabPage: number
  tabSimple: boolean
}

export interface FirstMarcLabelInput extends MarcLabelInput {
  secondMarcLabels: MarcLabelInput[]
}

interface NavItem {
  text: string
  key: string | number
}

// interface SeparateTag {
//   displayTag: string
//   displayMarcTag: string
//   dieplayValue: string
//   kanaTag: string
//   kanaMarcTag: string
//   kanaValue: string
// }

interface SeparateTag {
  displayTag: string
  displayMarcTag: string
  displayData: string
  kanaTag: string
  kanaMarcTag: string
  kanaData: string
}

@Component({
  components: {
    BibliographyTagInput,
    ModalFooter,
    ModalTextArea
  }
})
export default class ModalBibliographyTagDataEdit extends ComponentVue {
  debugMode: boolean = false

  firstMarcLabels: FirstMarcLabel[] = []

  firstMarcLabelInputs: FirstMarcLabelInput[] = []

  height: number = 0

  activeTab: number = 0

  navItems: NavItem[] = [
    // {
    //   text: 'すべて表示',
    //   key: 'all'
    // },
    {
      text: '簡易表示',
      key: 'simple'
    },
    {
      text: '管理情報',
      key: 1
    },
    {
      text: 'タイトル・責任表示',
      key: 2
    },
    {
      text: '出版',
      key: 3
    },
    {
      text: '件名',
      key: 4
    },
    {
      text: '注記',
      key: 5
    },
    {
      text: '目次',
      key: 6
    },
    {
      text: 'その他',
      key: 7
    }
  ]

  firstLabelSeq = new Map<string, number>()

  secondLabelSeq = new Map<string, number>()

  tagSeq = new Map<string, number>()

  get beforeOpen() {
    return modalBibliographyTagDataEditStore.beforeOpen
  }

  get isOpen() {
    return modalBibliographyTagDataEditStore.isOpen
  }

  get isEdit() {
    return modalBibliographyTagDataEditStore.isEdit
  }

  get isCopy() {
    return modalBibliographyTagDataEditStore.isCopy
  }

  get bibliographyClass() {
    return modalBibliographyTagDataEditStore.bibliographyClass
  }

  get searchType() {
    return modalBibliographyTagDataEditStore.searchType
  }

  get editBibliographyId() {
    return modalBibliographyTagDataEditStore.editBibliographyId
  }

  get bibliographyRealId() {
    return modalBibliographyTagDataEditStore.bibliographyRealId
  }

  get bibliographySetId() {
    return modalBibliographyTagDataEditStore.bibliographySetId
  }

  get serial() {
    return modalBibliographyTagDataEditStore.serial
  }

  get details() {
    return modalBibliographyTagDataEditStore.details
  }

  get authorities() {
    return modalBibliographyTagDataEditStore.authorities
  }

  get revision() {
    return modalBibliographyTagDataEditStore.revision
  }

  get title() {
    // 資料の管理：書誌の新規登録（図書）
    // 資料の管理：書誌の編集（図書）
    // 資料の管理：書誌の新規登録（ＡＶ）
    // 資料の管理：書誌の編集（ＡＶ）
    // 資料の管理：巻号の編集
    // 資料の管理：巻号の新規登録
    // 資料の管理：巻号の編集
    // 資料の管理：誌名の新規登録
    // 資料の管理：誌名の編集
    // 資料の管理：内容の新規登録
    // 資料の管理：内容の編集

    let title1: string
    if (this.bibliographyClass === BibliographyClass.Set) {
      title1 = '誌名'
    } else if (this.bibliographyClass === BibliographyClass.Content) {
      title1 = '内容'
    } else if (this.searchType.code === SearchType.Magazine) {
      title1 = '巻号'
    } else {
      title1 = '書誌'
    }

    const title2 = this.isEdit ? '編集' : this.isCopy ? '複写登録' : '新規登録'

    let title3 = ''
    if (this.bibliographyClass === BibliographyClass.Real) {
      if (this.searchType.code === SearchType.Book) {
        title3 = '（図書）'
      } else if (this.searchType.code === SearchType.Av) {
        title3 = '（ＡＶ）'
      }
    }

    return `資料の管理：${title1}の${title2}${title3}`
  }

  get isCurrentFirstLabel() {
    return (no: string, tagGroup: string) => {
      const seq = this.firstLabelSeq.get(tagGroup)
      if (seq === undefined) return false

      return Number(no) === seq
    }
  }

  get removableFirstLabel() {
    return (tagGroup: string) => {
      const count = countBy(this.firstMarcLabelInputs, item => {
        return item.tagGroup
      })
      return count[tagGroup] > 1
    }
  }

  get removableFirstTag() {
    return (tagGroup: string, topNumber: string, marcTag: string) => {
      const firstMarcLabelInput = this.firstMarcLabelInputs.find(
        item => item.tagGroup === tagGroup && item.no === topNumber
      )
      if (firstMarcLabelInput === undefined) return false

      const count = countBy(
        firstMarcLabelInput.tags,
        (item: MarcTagInputData) => {
          return item.default.marcTag
        }
      )
      return count[marcTag] > 1
    }
  }

  get isCurrentSecondLabel() {
    return (no: string, tagGroup: string, topNumber: string) => {
      const seq = this.secondLabelSeq.get(`${tagGroup}-${topNumber}`)
      if (seq === undefined) return false

      return Number(no) === seq
    }
  }

  get removableSecondLabel() {
    return (firstLabel: FirstMarcLabelInput, secondTagGroup: string) => {
      const count = countBy(firstLabel.secondMarcLabels, item => {
        return item.tagGroup
      })
      return count[secondTagGroup] > 1
    }
  }

  get removableSecondTag() {
    return (secondLabel: MarcLabelInput, marcTag: string) => {
      const count = countBy(secondLabel.tags, (item: MarcTagInputData) => {
        return item.default.marcTag
      })
      return count[marcTag] > 1
    }
  }

  get isCurrentTag() {
    return (
      no: string,
      marcTag: string,
      topNumber: string,
      middleNumber: string = ''
    ) => {
      let tagSeqKey = `${marcTag}-${topNumber}`
      if (middleNumber !== '') {
        tagSeqKey += `-${middleNumber}`
      }
      const seq = this.tagSeq.get(tagSeqKey)
      if (seq === undefined) return false

      return Number(no) === seq
    }
  }

  get filteredMarcLabelInputs() {
    const navItem = this.navItems[this.activeTab]
    return this.firstMarcLabelInputs.filter(item => {
      if (navItem.key === 'simple') {
        return item.tabSimple
      }

      if (typeof navItem.key === 'number') {
        return item.tabPage === navItem.key
      }
    })
  }

  get requiredLabel() {
    return (label: FirstMarcLabelInput) => {
      return label.labelName === '本タイトル' && label.no === '0001'
    }
  }

  get showDetailIcon() {
    return (fieldType: string) => {
      return (
        fieldType !== 'number' &&
        fieldType !== 'alpha_number' &&
        fieldType !== 'alpha_mark_number' &&
        fieldType !== 'date' &&
        fieldType !== 'system_code' &&
        fieldType !== 'system_code_name' &&
        fieldType !== 'authority_author_no' &&
        fieldType !== 'authority_publisher_no' &&
        fieldType !== 'authority_subject_no' &&
        fieldType !== 'authority_series_no' &&
        fieldType !== 'authority_complete_works_no'
      )
    }
  }

  @Watch('beforeOpen')
  onChangeBeforeOpen() {
    if (this.beforeOpen) {
      this.fetchMarcLabel()
    }
  }

  @Watch('isOpen')
  initialize() {
    if (this.isOpen) {
      this.activeTab = 0
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize)
        this.calculateTableHeight()
      })
      return
    }

    window.removeEventListener('resize', this.onResize)
  }

  @Ref()
  modalTextArea!: ModalTextArea

  close() {
    modalBibliographyTagDataEditStore.close()
  }

  requiredTag(tag: string): boolean {
    const isTagKana = tag === this.kanaTitleTag()

    if (this.bibliographyClass === BibliographyClass.Content) {
      return (
        !dataStore.requiredNotationOrKanaBibliographyDetailContentTab &&
        isTagKana
      )
    }

    return isTagKana
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-bibliography-tag-data-edit')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  onClickCancel() {
    const alert: Alert = AlertFactory.create(AlertCodeALC00002)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        modalBibliographyTagDataEditStore.cancel()
        this.close()
      }
    })
  }

  onClickOk() {
    const alert: Alert = AlertFactory.create(AlertCodeCLT00042, '書誌')
    alertStore.setItem(alert)
    this.$modalAlert.open({
      modalType: 'WARN',
      onOkClick: () => {
        if (this.isEdit) {
          this.update()
        } else {
          this.create()
        }
      }
    })
  }

  dataUpdated(bibliographyId: number, title: string) {
    modalBibliographyTagDataEditStore.ok({ bibliographyId, title })
    this.close()
  }

  async fetchMarcLabel(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.firstMarcLabels = await marcLabelApi.getAll(
        this.bibliographyClass,
        this.searchType,
        this.isEdit
      )

      this.createFirstMarcLabelInput()

      this.$eventBus.emit(NAV_LOADING_END)

      modalBibliographyTagDataEditStore.ready()
    } catch (error) {
      if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async update() {
    this.$eventBus.emit(PAGE_LOADING_START)

    if (this.editBibliographyId === undefined || this.revision === undefined) {
      return
    }

    const registerDetails = this.createRegisterDetails()

    let titleItem = registerDetails.find(item => {
      return item.tag === this.displayTitleTag()
    })

    if (titleItem === undefined) {
      titleItem = registerDetails.find(item => {
        return item.tag === this.kanaTitleTag()
      })
    }

    const title = titleItem !== undefined ? titleItem.data : ''

    try {
      if (this.bibliographyClass === BibliographyClass.Set) {
        await bibliographySetApi.updateBibliographySet(
          this.editBibliographyId,
          {
            details: registerDetails,
            revision: this.revision
          }
        )
      } else if (this.bibliographyClass === BibliographyClass.Content) {
        await bibliographyContentApi.update(this.editBibliographyId, {
          details: registerDetails,
          revision: this.revision
        })
      } else {
        await bibliographyRealApi.updateBibliographyReal(
          this.editBibliographyId,
          {
            details: registerDetails,
            revision: this.revision
          }
        )
      }

      this.dataUpdated(this.editBibliographyId, title)
    } catch (error) {
      if (error instanceof AlertMessage) {
        console.error(error.alerts)
        alertStore.setItems(error.alerts)
        this.setAlertMessage(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async create() {
    this.$eventBus.emit(PAGE_LOADING_START)

    const registerDetails = this.createRegisterDetails()

    let titleItem = registerDetails.find(item => {
      return item.tag === this.displayTitleTag()
    })

    if (titleItem === undefined) {
      titleItem = registerDetails.find(item => {
        return item.tag === this.kanaTitleTag()
      })
    }

    const title = titleItem !== undefined ? titleItem.data : ''

    try {
      let bibliographyId
      if (this.bibliographyClass === BibliographyClass.Set) {
        bibliographyId = await bibliographySetApi.createBibliographySet({
          searchType: this.searchType,
          details: registerDetails
        })
      } else if (this.bibliographyClass === BibliographyClass.Content) {
        bibliographyId = await bibliographyContentApi.create({
          searchType: this.searchType,
          serial: this.serial,
          bibliographyRealId: this.bibliographyRealId,
          details: registerDetails
        })
      } else {
        bibliographyId = await bibliographyRealApi.createBibliographyReal({
          searchType: this.searchType,
          bibliographySetId: this.bibliographySetId,
          details: registerDetails
        })
      }
      this.dataUpdated(bibliographyId, title)
    } catch (error) {
      if (error instanceof AlertMessage) {
        console.error(error.alerts)
        alertStore.setItems(error.alerts)
        this.setAlertMessage(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  setAlertMessage(alerts: Alert[] = []) {
    alerts.forEach(alert => {
      for (let i = 0; i < this.firstMarcLabelInputs.length; i++) {
        const item = this.firstMarcLabelInputs[i]

        for (let j = 0; j < item.tags.length; j++) {
          const tag = item.tags[j]

          if (tag.authorityName?.tag === alert.attribute) {
            tag.authorityName.errorMessage = alert.message
            break
          }

          if (tag.authorityKana?.tag === alert.attribute) {
            tag.authorityKana.errorMessage = alert.message
            break
          }

          if (tag.authorityRole?.tag === alert.attribute) {
            tag.authorityRole.errorMessage = alert.message
            break
          }

          if (tag.default.tag === alert.attribute) {
            tag.default.errorMessage = alert.message
            break
          }
        }

        for (let k = 0; k < item.secondMarcLabels.length; k++) {
          const secondItem = item.secondMarcLabels[k]

          for (let j = 0; j < secondItem.tags.length; j++) {
            const tag = secondItem.tags[j]

            if (tag.authorityName?.tag === alert.attribute) {
              tag.authorityName.errorMessage = alert.message
              break
            }

            if (tag.authorityKana?.tag === alert.attribute) {
              tag.authorityKana.errorMessage = alert.message
              break
            }

            if (tag.authorityRole?.tag === alert.attribute) {
              tag.authorityRole.errorMessage = alert.message
              break
            }

            if (tag.default.tag === alert.attribute) {
              tag.default.errorMessage = alert.message
              break
            }
          }
        }
      }
    })
  }

  createRegisterDetails(): BibliographyTagRegisterData[] {
    const tagDataInputs: BibliographyTagRegisterData[] = []

    this.firstMarcLabelInputs.forEach(
      (firstMarcLabelInput: FirstMarcLabelInput) => {
        firstMarcLabelInput.tags.forEach(
          (marcTagInputData: MarcTagInputData) => {
            if (
              marcTagInputData.default.data !== '' &&
              marcTagInputData.default.data !== '|'
            ) {
              tagDataInputs.push({
                tag: marcTagInputData.default.tag,
                data: marcTagInputData.default.data,
                marcTag: marcTagInputData.default.marcTag
              })
            }

            if (marcTagInputData.marcNo !== undefined) {
              if (marcTagInputData.marcNo.data !== '') {
                tagDataInputs.push({
                  tag: marcTagInputData.marcNo.tag,
                  data: marcTagInputData.marcNo.data,
                  marcTag: marcTagInputData.marcNo.marcTag
                })
              }
            }
          }
        )

        firstMarcLabelInput.secondMarcLabels.forEach(
          (secondMarcLabelInput: MarcLabelInput) => {
            secondMarcLabelInput.tags.forEach(
              (marcTagInputData: MarcTagInputData) => {
                if (
                  marcTagInputData.default.data !== '' &&
                  marcTagInputData.default.data !== '|'
                ) {
                  tagDataInputs.push({
                    tag: marcTagInputData.default.tag,
                    data: marcTagInputData.default.data,
                    marcTag: marcTagInputData.default.marcTag
                  })
                }

                if (marcTagInputData.marcNo !== undefined) {
                  if (marcTagInputData.marcNo.data !== '') {
                    tagDataInputs.push({
                      tag: marcTagInputData.marcNo.tag,
                      data: marcTagInputData.marcNo.data,
                      marcTag: marcTagInputData.marcNo.marcTag
                    })
                  }
                }

                if (marcTagInputData.authorityRole !== undefined) {
                  if (marcTagInputData.authorityRole.data !== '') {
                    tagDataInputs.push({
                      tag: marcTagInputData.authorityRole.tag,
                      data: marcTagInputData.authorityRole.data,
                      marcTag: marcTagInputData.authorityRole.marcTag
                    })
                  }
                }
              }
            )
          }
        )
      }
    )

    return tagDataInputs
  }

  createFirstMarcLabelInput() {
    const details = cloneDeep(this.details)

    this.firstMarcLabelInputs = []
    this.firstLabelSeq.clear()
    this.secondLabelSeq.clear()
    this.tagSeq.clear()

    for (let i = 0; i < this.firstMarcLabels.length; i++) {
      const firstLabel = this.firstMarcLabels[i]

      // 上位番号取得
      const topNumbers: string[] = []
      let topNumberReg
      if (firstLabel.tagGroup === 'E0') {
        // フリーワードだけ第一階層の連番が中位番号のため、中位番号から連番を取得
        topNumberReg = new RegExp(`^E00001[0-9n]{2}([0-9]{4})[0-9n]{6}$`)
      } else {
        topNumberReg = new RegExp(
          `^${firstLabel.tagGroup}([0-9]{4})[0-9n]{12}$`
        )
      }
      for (let j = 0; j < details.length; j++) {
        const detail = details[j]
        const matchTag = detail.tag.match(topNumberReg)

        if (matchTag !== null) {
          if (!topNumbers.includes(matchTag[1])) {
            topNumbers.push(matchTag[1])
          }
        }
      }

      if (topNumbers.length === 0) {
        topNumbers.push('0001')
      }

      // ラベルインデックスが必ず1から始まるようにする
      topNumbers.sort()

      topNumbers.forEach(topNumber => {
        const labelTag = `${firstLabel.tagGroup}`
        const seq = this.firstLabelSeq.get(labelTag)
        if (seq !== undefined) {
          this.firstLabelSeq.set(labelTag, seq + 1)
        } else {
          this.firstLabelSeq.set(labelTag, Number(topNumber))
        }
        const firstMarcLabelItem = this.createFirstMarcLabelInputData(
          firstLabel,
          topNumber
        )

        if (firstMarcLabelItem !== undefined) {
          this.firstMarcLabelInputs.push(firstMarcLabelItem)
        }
      })
    }

    return this.firstMarcLabelInputs
  }

  createFirstMarcLabelInputData(
    firstLabel: FirstMarcLabel,
    nextNumber: string
  ): FirstMarcLabelInput | undefined {
    const firstMarcLabelItem: FirstMarcLabelInput = {
      labelName: firstLabel.labelName,
      repeat: firstLabel.repeat,
      tags: [],
      no: nextNumber,
      tagGroup: firstLabel.tagGroup,
      secondMarcLabels: [],
      tabPage: firstLabel.tabPage,
      tabSimple: firstLabel.tabSimple
    }

    // 第1階層tagデータ算出
    for (let t = 0; t < firstLabel.tags.length; t++) {
      const tagItem = firstLabel.tags[t]
      const isNumberTag = this.isNumberTag(tagItem.tag)
      const isNumberTypeTag = this.isNumberTypeTag(tagItem.tag)
      const isRoleTag = this.isRoleTag(tagItem.tag)
      const isAuthorityTag = tagItem.fieldType.startsWith('authority_')

      // tag番号取得
      const tagReg = new RegExp(
        '^([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}$'
      )
      const tags = tagItem.tag.match(tagReg)
      if (tags == null) {
        continue
      }

      // 上中下番号取得
      const numberTagReg = new RegExp(
        '^[0-9A-Z]{2}([0-9n]{4})[0-9A-Z]{2}([0-9n]{4})[0-9A-Z]{2}([0-9n]{4})$'
      )
      const numberTag = tagItem.tag.match(numberTagReg)
      if (numberTag === null) {
        continue
      }

      // MARC番号、カード番号、その他番号は区分表示時に処理するため何もしない
      if (isNumberTag) {
        continue
      }

      // 役割区分は典拠表記表示時に処理するため何もしない
      if (isRoleTag) {
        continue
      }

      // フリーワードだけ第一階層の連番が中位番号のため、中位番号から連番を取得
      const topNumber = tags[1] === 'E0' ? '0001' : nextNumber
      const middleNumber = tags[1] === 'E0' ? nextNumber : '0001'

      // 下位番号取得
      const bottomNumberRegValue =
        numberTag[3] === 'nnnn' ? '[0-9n]{4}' : numberTag[3]
      const bottomNumberReg = new RegExp(
        `^${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}(${bottomNumberRegValue})$`
      )

      let isMatch = false

      for (let j = 0; j < this.details.length; j++) {
        const detail = this.details[j]
        const matchTag = detail.tag.match(bottomNumberReg)

        if (matchTag !== null) {
          const bottomNumber = matchTag[1]
          const tag = `${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}${bottomNumber}`

          const marcTagData: MarcTagInput = {
            tag,
            marcTag: tagItem.tag,
            labelName: tagItem.labelName,
            repeat: tagItem.repeat,
            fieldType: tagItem.fieldType,
            maxLength: tagItem.maxLength,
            systemCodeKey: tagItem.systemCodeKey,
            no: bottomNumber,
            data: detail.data,
            errorMessage: '',
            isMarcTypeField: false,
            isAuthorityNameField: false,
            isAuthorityKanaField: false
          }
          const marcTagInputData: MarcTagInputData = {
            default: marcTagData
          }

          if (isNumberTypeTag) {
            marcTagInputData.default.isMarcTypeField = true

            const numberTagItem = this.createNumberTag(
              tag,
              tagItem,
              bottomNumber
            )
            if (numberTagItem !== undefined) {
              marcTagInputData.marcNo = numberTagItem

              // MARC番号は重複データを登録させたくない為、入力値は複写させない仕様とする
              if (
                this.isCopy &&
                this.isMarcNumberTypeTag(marcTagInputData.default.marcTag)
              ) {
                marcTagInputData.default.data = ''
                marcTagInputData.marcNo.data = ''
              }
            }
          } else if (isAuthorityTag) {
            marcTagInputData.default.isAuthorityNameField = true

            const authorityRolTag = this.createAuthorityRoleTag(
              tag,
              tagItem,
              `${tags[1]}${topNumber}${tags[2]}${middleNumber}04${bottomNumber}`,
              detail.data,
              bottomNumber
            )
            if (authorityRolTag !== undefined) {
              marcTagInputData.authorityRole = authorityRolTag
            }

            const authorityTagItems = this.createAuthorityTag(
              tag,
              tagItem,
              detail.data,
              bottomNumber
            )

            marcTagInputData.authorityName = authorityTagItems[0]
            marcTagInputData.authorityKana = authorityTagItems[1]
          }

          firstMarcLabelItem.tags.push(marcTagInputData)

          const tagSeqKey = `${tagItem.tag}-${nextNumber}`
          const seq = this.tagSeq.get(tagSeqKey)
          if (seq !== undefined) {
            this.tagSeq.set(tagSeqKey, seq + 1)
          } else {
            this.tagSeq.set(tagSeqKey, Number(bottomNumber))
          }

          isMatch = true
        }
      }

      if (!isMatch) {
        const bottomNumberWithN = tagItem.tag.substr(-4, 4)
        const bottomNumber =
          bottomNumberWithN === 'nnnn' ? '0001' : bottomNumberWithN
        const tag = `${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}${bottomNumber}`
        const marcTagData: MarcTagInput = {
          tag,
          marcTag: tagItem.tag,
          labelName: tagItem.labelName,
          repeat: tagItem.repeat,
          fieldType: tagItem.fieldType,
          maxLength: tagItem.maxLength,
          systemCodeKey: tagItem.systemCodeKey,
          no: bottomNumber,
          // TRC初期値は必要か不明なので一旦コメントアウト by nagasu
          // data: this.isMarcNumberTypeTag(tagItem.tag) ? 'TRC' : '',
          data: '',
          errorMessage: '',
          isMarcTypeField: false,
          isAuthorityNameField: false,
          isAuthorityKanaField: false
        }
        const marcTagInputData: MarcTagInputData = {
          default: marcTagData
        }

        // MARC区分・番号
        if (isNumberTypeTag) {
          marcTagInputData.default.isMarcTypeField = true

          const numberTagItem = this.createNumberTag(tag, tagItem, bottomNumber)
          if (numberTagItem !== undefined) {
            marcTagInputData.marcNo = numberTagItem

            // MARC番号は重複データを登録させたくない為、入力値は複写させない仕様とする
            if (
              this.isCopy &&
              this.isMarcNumberTypeTag(marcTagInputData.default.marcTag)
            ) {
              marcTagInputData.default.data = ''
              marcTagInputData.marcNo.data = ''
            }
          }
        } else if (isAuthorityTag) {
          marcTagInputData.default.isAuthorityNameField = true
          const authorityRolTag = this.createAuthorityRoleTag(
            tag,
            tagItem,
            `${tags[1]}${topNumber}${tags[2]}${middleNumber}04${bottomNumber}`,
            '',
            bottomNumber
          )
          if (authorityRolTag !== undefined) {
            marcTagInputData.authorityRole = authorityRolTag
          }

          const authorityTagItems = this.createAuthorityTag(
            tag,
            tagItem,
            '',
            bottomNumber
          )

          marcTagInputData.authorityName = authorityTagItems[0]
          marcTagInputData.authorityKana = authorityTagItems[1]
        }

        firstMarcLabelItem.tags.push(marcTagInputData)

        const tagSeqKey = `${tagItem.tag}-${nextNumber}`
        const seq = this.tagSeq.get(tagSeqKey)
        if (seq !== undefined) {
          this.tagSeq.set(tagSeqKey, seq + 1)
        } else {
          this.tagSeq.set(tagSeqKey, Number(bottomNumber))
        }
      }
    }

    // 第2階層ラベルデータ算出
    firstMarcLabelItem.secondMarcLabels = this.createSecondLabelInput(
      firstLabel,
      nextNumber
    )

    if (
      firstMarcLabelItem.tags.length > 0 ||
      firstMarcLabelItem.secondMarcLabels.length > 0
    ) {
      return firstMarcLabelItem
    }
  }

  createSecondLabelInput(firstLabel: FirstMarcLabel, topNumber: string) {
    const secondMarcLabelItems: MarcLabelInput[] = []

    for (let i = 0; i < firstLabel.secondMarcLabels.length; i++) {
      const secondLabel = firstLabel.secondMarcLabels[i]

      // 中位番号取得
      const middleNumbers: string[] = []
      for (let j = 0; j < secondLabel.tags.length; j++) {
        const tagItem = secondLabel.tags[j]

        // tag番号取得
        const tagReg = new RegExp(
          '^([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}$'
        )
        const tags = tagItem.tag.match(tagReg)
        if (tags === null) {
          continue
        }

        // 中位tag番号取得
        const middleNumberReg = new RegExp(
          `^${tags[1]}${topNumber}${tags[2]}([0-9]{4})${tags[3]}[0-9]{4}$`
        )
        for (let j = 0; j < this.details.length; j++) {
          const detail = this.details[j]
          const matchTag = detail.tag.match(middleNumberReg)

          if (matchTag !== null) {
            if (!middleNumbers.includes(matchTag[1])) {
              middleNumbers.push(matchTag[1])
            }
          }
        }
      }

      if (middleNumbers.length === 0) {
        middleNumbers.push('0001')
      }

      // ラベルインデックスが必ず1から始まるようにする
      middleNumbers.sort()

      middleNumbers.forEach(middleNumber => {
        const labelTag = `${secondLabel.tagGroup}-${topNumber}`
        const seq = this.firstLabelSeq.get(labelTag)
        if (seq !== undefined) {
          this.secondLabelSeq.set(labelTag, seq + 1)
        } else {
          this.secondLabelSeq.set(labelTag, Number(middleNumber))
        }

        const secondMarcLabelItem = this.createSecondLabelInputData(
          secondLabel,
          topNumber,
          middleNumber
        )

        if (secondMarcLabelItem !== undefined) {
          secondMarcLabelItems.push(secondMarcLabelItem)
        }
      })
    }

    return secondMarcLabelItems
  }

  createSecondLabelInputData(
    secondLabel: MarcLabel,
    topNumber: string,
    middleNumber: string
  ): MarcLabelInput | undefined {
    const marcLabelInput: MarcLabelInput = {
      labelName: secondLabel.labelName,
      repeat: secondLabel.repeat,
      tags: [],
      no: middleNumber,
      tagGroup: secondLabel.tagGroup,
      tabPage: secondLabel.tabPage,
      tabSimple: secondLabel.tabSimple
    }

    // 第2階層tagデータ算出
    for (let t = 0; t < secondLabel.tags.length; t++) {
      const tagItem = secondLabel.tags[t]
      const isNumberTag = this.isNumberTag(tagItem.tag)
      const isNumberTypeTag = this.isNumberTypeTag(tagItem.tag)
      const isRoleTag = this.isRoleTag(tagItem.tag)
      const isAuthorityTag = tagItem.fieldType.startsWith('authority_')

      // tag番号取得
      const tagReg = new RegExp(
        '^([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}([0-9A-Z]{2})[0-9n]{4}$'
      )
      const tags = tagItem.tag.match(tagReg)
      if (tags === null) {
        continue
      }

      // MARC番号、カード番号、その他番号は区分表示時に処理するため何もしない
      if (isNumberTag) {
        continue
      }

      // 役割区分は典拠表記表示時に処理するため何もしない
      if (isRoleTag) {
        continue
      }

      // 下位番号取得
      const bottomNumberWithN = tagItem.tag.substr(-4, 4)
      const bottomNumberRegValue =
        bottomNumberWithN === 'nnnn' ? '[0-9n]{4}' : bottomNumberWithN
      const bottomNumberReg = new RegExp(
        `^${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}(${bottomNumberRegValue})$`
      )

      let isMatch = false

      for (let j = 0; j < this.details.length; j++) {
        const detail = this.details[j]
        const matchTag = detail.tag.match(bottomNumberReg)

        if (matchTag !== null) {
          const bottomNumber = matchTag[1]
          const tag = `${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}${bottomNumber}`
          const marcTagData: MarcTagInput = {
            tag, // + ' -> ' + detail.tag,
            marcTag: tagItem.tag,
            labelName: tagItem.labelName,
            repeat: tagItem.repeat,
            fieldType: tagItem.fieldType,
            maxLength: tagItem.maxLength,
            systemCodeKey: tagItem.systemCodeKey,
            no: bottomNumber,
            data: detail.data,
            errorMessage: '',
            isMarcTypeField: false,
            isAuthorityNameField: false,
            isAuthorityKanaField: false
          }

          const marcTagInputData: MarcTagInputData = {
            default: marcTagData
          }

          if (isNumberTypeTag) {
            marcTagInputData.default.isMarcTypeField = true

            const numberTagItem = this.createNumberTag(
              tag,
              tagItem,
              bottomNumber
            )

            if (numberTagItem !== undefined) {
              marcTagInputData.marcNo = numberTagItem
            }
          } else if (isAuthorityTag) {
            marcTagInputData.default.isAuthorityNameField = true
            const authorityRolTag = this.createAuthorityRoleTag(
              tag,
              tagItem,
              `${tags[1]}${topNumber}${tags[2]}${middleNumber}04${bottomNumber}`,
              detail.data,
              bottomNumber
            )
            if (authorityRolTag !== undefined) {
              marcTagInputData.authorityRole = authorityRolTag
            }

            const authorityTagItems = this.createAuthorityTag(
              tag,
              tagItem,
              detail.data,
              bottomNumber
            )

            marcTagInputData.authorityName = authorityTagItems[0]
            marcTagInputData.authorityKana = authorityTagItems[1]
          }

          marcLabelInput.tags.push(marcTagInputData)

          const tagSeqKey = `${tagItem.tag}-${topNumber}-${middleNumber}`
          const seq = this.tagSeq.get(tagSeqKey)
          if (seq !== undefined) {
            this.tagSeq.set(tagSeqKey, seq + 1)
          } else {
            this.tagSeq.set(tagSeqKey, Number(bottomNumber))
          }

          isMatch = true
        }
      }

      if (!isMatch) {
        const bottomNumberWithN = tagItem.tag.substr(-4, 4)
        const bottomNumber =
          bottomNumberWithN === 'nnnn' ? '0001' : bottomNumberWithN
        const tag = `${tags[1]}${topNumber}${tags[2]}${middleNumber}${tags[3]}${bottomNumber}`
        const marcTagData: MarcTagInput = {
          tag, // + ' -> ' + detail.tag,
          marcTag: tagItem.tag,
          labelName: tagItem.labelName,
          repeat: tagItem.repeat,
          fieldType: tagItem.fieldType,
          maxLength: tagItem.maxLength,
          systemCodeKey: tagItem.systemCodeKey,
          no: bottomNumber,
          data: '',
          errorMessage: '',
          isMarcTypeField: false,
          isAuthorityNameField: false,
          isAuthorityKanaField: false
        }

        const marcTagInputData: MarcTagInputData = {
          default: marcTagData
        }

        if (isNumberTypeTag) {
          marcTagInputData.default.isMarcTypeField = true

          const numberTagItem = this.createNumberTag(tag, tagItem, bottomNumber)
          if (numberTagItem !== undefined) {
            marcTagInputData.marcNo = numberTagItem
          }
        } else if (isAuthorityTag) {
          marcTagInputData.default.isAuthorityNameField = true
          const authorityRolTag = this.createAuthorityRoleTag(
            tag,
            tagItem,
            `${tags[1]}${topNumber}${tags[2]}${middleNumber}04${bottomNumber}`,
            '',
            bottomNumber
          )
          if (authorityRolTag !== undefined) {
            marcTagInputData.authorityRole = authorityRolTag
          }

          const authorityTagItems = this.createAuthorityTag(
            tag,
            tagItem,
            '',
            bottomNumber
          )

          marcTagInputData.authorityName = authorityTagItems[0]
          marcTagInputData.authorityKana = authorityTagItems[1]
        }

        marcLabelInput.tags.push(marcTagInputData)

        const tagSeqKey = `${tagItem.tag}-${topNumber}-${middleNumber}`
        const seq = this.tagSeq.get(tagSeqKey)
        if (seq !== undefined) {
          this.tagSeq.set(tagSeqKey, seq + 1)
        } else {
          this.tagSeq.set(tagSeqKey, Number(bottomNumber))
        }
      }
    }

    if (marcLabelInput.tags.length > 0) {
      return marcLabelInput
    }
  }

  createNumberTag(
    tag: string,
    tagItem: MarcTag,
    bottomNumber: string
  ): MarcTagInput | undefined {
    // MARC区分タグと紐づく、MARC番号タグ
    const marcNumberTag = `${tagItem.tag.substr(0, 12)}02${bottomNumber}`
    const marcNumberItem = this.details.find(item => item.tag === marcNumberTag)
    const marcNumberData = marcNumberItem ? marcNumberItem.data : ''
    const marcNumberMarcTag = this.findMarcTag(
      `${tagItem.tag.substr(0, 12)}02${tagItem.tag.substr(14)}`
    )

    if (marcNumberMarcTag === undefined) {
      return
    }

    return {
      tag: marcNumberTag,
      marcTag: marcNumberMarcTag.tag,
      labelName: marcNumberMarcTag.labelName,
      repeat: marcNumberMarcTag.repeat,
      fieldType: marcNumberMarcTag.fieldType,
      maxLength: marcNumberMarcTag.maxLength,
      systemCodeKey: marcNumberMarcTag.systemCodeKey,
      no: bottomNumber,
      data: marcNumberData,
      errorMessage: '',
      isMarcTypeField: false,
      isAuthorityNameField: false,
      isAuthorityKanaField: false
    }
  }

  createAuthorityRoleTag(
    tag: string,
    tagItem: MarcTag,
    roleTag: string,
    authorityNo: string,
    bottomNumber: string
  ): MarcTagInput | undefined {
    // 叢書表記は対象外
    if (tagItem.fieldType === 'authority_series_no') {
      return undefined
    }

    // 役割区分
    const roleData = this.details.find(item => item.tag === roleTag)
    const roleName = roleData ? roleData.data : ''
    const roleMarcTag = this.findMarcTag(
      `${roleTag.substr(0, 2)}nnnn05nnnn040001`
    )

    if (roleMarcTag) {
      return {
        tag: roleTag,
        marcTag: roleMarcTag.tag,
        labelName: roleMarcTag.labelName,
        repeat: roleMarcTag.repeat,
        fieldType: roleMarcTag.fieldType,
        maxLength: roleMarcTag.maxLength,
        systemCodeKey: roleMarcTag.systemCodeKey,
        no: bottomNumber,
        data: roleName,
        errorMessage: '',
        isMarcTypeField: false,
        isAuthorityNameField: false,
        isAuthorityKanaField: false
      }
    }

    return undefined
  }

  createAuthorityTag(
    tag: string,
    tagItem: MarcTag,
    authorityNo: string,
    bottomNumber: string
  ): MarcTagInput[] {
    const marcTagInputs: MarcTagInput[] = []

    // 表記
    const authorityNameItem = this.authorities.find(authority => {
      return (
        authorityNo === authority.authorityNo &&
        authority.authorityTag ===
          this.getAuthorityDisplayTag(tagItem.fieldType)
      )
    })

    const marcTagData: MarcTagInput = {
      tag, // + ' -> ' + detail.tag,
      marcTag: tagItem.tag,
      labelName: tagItem.labelName,
      repeat: tagItem.repeat,
      fieldType: tagItem.fieldType,
      maxLength: tagItem.maxLength,
      systemCodeKey: tagItem.systemCodeKey,
      no: bottomNumber,
      data: authorityNameItem ? authorityNameItem.data : '',
      errorMessage: '',
      isMarcTypeField: false,
      isAuthorityNameField: true,
      isAuthorityKanaField: false,
      authorityNo
    }
    marcTagInputs.push(marcTagData)

    // カナ
    const authorityKanaItem = this.authorities.find(authority => {
      return (
        authorityNo === authority.authorityNo &&
        authority.authorityTag === this.getAuthorityKanaTag(tagItem.fieldType)
      )
    })

    const marcTagDataKana: MarcTagInput = {
      tag, // + ' -> ' + detail.tag,
      marcTag: tagItem.tag,
      labelName: tagItem.labelName,
      repeat: tagItem.repeat,
      fieldType: tagItem.fieldType,
      maxLength: tagItem.maxLength,
      systemCodeKey: tagItem.systemCodeKey,
      no: bottomNumber,
      data: authorityKanaItem ? authorityKanaItem.data : '',
      errorMessage: '',
      isMarcTypeField: false,
      isAuthorityNameField: false,
      isAuthorityKanaField: true,
      authorityNo
    }
    marcTagInputs.push(marcTagDataKana)

    return marcTagInputs
  }

  findMarcTag(targetTag: string): MarcTag | undefined {
    for (let i = 0; i < this.firstMarcLabels.length; i++) {
      const firstMarcLabel = this.firstMarcLabels[i]

      for (let j = 0; j < firstMarcLabel.tags.length; j++) {
        const marcTag = firstMarcLabel.tags[j]
        if (marcTag.tag === targetTag) return marcTag
      }

      for (let k = 0; k < firstMarcLabel.secondMarcLabels.length; k++) {
        const secondMarcLabel = firstMarcLabel.secondMarcLabels[k]

        for (let t = 0; t < secondMarcLabel.tags.length; t++) {
          const marcTag = secondMarcLabel.tags[t]
          if (marcTag.tag === targetTag) return marcTag
        }
      }
    }

    return undefined
  }

  setAuthorityText(data: MarcTagInputData) {
    data.default.data = `${data.authorityName?.data}|${data.authorityKana?.data}`
    if (data.authorityName !== undefined) {
      data.authorityName.authorityNo = ''
    }
    if (data.authorityKana !== undefined) {
      data.authorityKana.authorityNo = ''
    }
  }

  setAuthority(data: MarcTagInputData, item: AuthorityItem) {
    data.default.data = item.authorityNo
    if (data.authorityName !== undefined) {
      data.authorityName.authorityNo = item.authorityNo
      data.authorityName.data = item.display
    }
    if (data.authorityKana !== undefined) {
      data.authorityKana.authorityNo = item.authorityNo
      data.authorityKana.data = item.displayKana
    }
  }

  // MARC・番号区分
  isNumberTypeTag(tag: string) {
    return [
      '00000112000101nnnn',
      '00000119000101nnnn',
      '00000120000101nnnn'
    ].includes(tag)
  }

  // MARC区分
  isMarcNumberTypeTag(tag: string) {
    return ['00000112000101nnnn'].includes(tag)
  }

  // MARC番号、カード番号、その他番号
  isNumberTag(tag: string) {
    return [
      '00000112000102nnnn',
      '00000119000102nnnn',
      '00000120000102nnnn'
    ].includes(tag)
  }

  // 役割区分
  isRoleTag(tag: string) {
    return [
      '10nnnn05nnnn040001',
      '12nnnn05nnnn040001',
      '50nnnn05nnnn040001',
      '60nnnn05nnnn040001'
    ].includes(tag)
  }

  // タイトルカナ
  kanaTitleTag() {
    return '100001010001050001'
  }

  // 表記
  displayTitleTag() {
    return '100001010001020001'
  }

  getAuthorityDisplayTag(tag: string) {
    switch (tag) {
      case 'authority_author_no':
        return TagAuthorityAuthorDisplay
      case 'authority_publisher_no':
        return TagAuthorityPublisherDisplay
      case 'authority_subject_no':
        return TagAuthoritySubjectDisplay
      case 'authority_series_no':
        return TagAuthoritySeriesDisplay
      case 'authority_complete_works_no':
        return TagAuthorityCompleteWorksDisplay
    }
    console.error('getAuthorityDisplayTag 未定義：', tag)

    return ''
  }

  getAuthorityKanaTag(tag: string) {
    switch (tag) {
      case 'authority_author_no':
        return TagAuthorityAuthorKana
      case 'authority_publisher_no':
        return TagAuthorityPublisherKana
      case 'authority_subject_no':
        return TagAuthoritySubjectKana
      case 'authority_series_no':
        return TagAuthoritySeriesKana
      case 'authority_complete_works_no':
        return TagAuthorityCompleteWorksKana
    }
    console.error('getAuthorityKanaTag 未定義：', tag)

    return ''
  }

  onClickAddFirstLabel(marcLabelInput: MarcLabelInput) {
    let firstLabelIndex
    let firstLabel: FirstMarcLabelInput | undefined
    for (
      firstLabelIndex = this.firstMarcLabelInputs.length - 1;
      firstLabelIndex >= 0;
      firstLabelIndex--
    ) {
      firstLabel = this.firstMarcLabelInputs[firstLabelIndex]

      if (firstLabel.tagGroup === marcLabelInput.tagGroup) {
        break
      }
    }
    if (firstLabel === undefined) return

    if (firstLabel.tagGroup === 'E0') {
      // debugger
    }

    const firstLabelSeqKey = `${firstLabel.tagGroup}`
    const seq = this.firstLabelSeq.get(firstLabelSeqKey)
    const nextSeq = seq !== undefined ? seq + 1 : 1
    const nextTopNumber = nextSeq.toString().padStart(4, '0')

    const firstMarcLabel = this.firstMarcLabels.find(item => {
      return item.tagGroup === firstLabel?.tagGroup
    })

    if (firstMarcLabel === undefined) return

    const firstMarcLabelItem = this.createFirstMarcLabelInputData(
      firstMarcLabel,
      nextTopNumber
    )

    if (firstMarcLabelItem !== undefined) {
      this.firstMarcLabelInputs.splice(
        firstLabelIndex + 1,
        0,
        firstMarcLabelItem
      )
      this.firstLabelSeq.set(firstLabelSeqKey, nextSeq)
    }
  }

  onClickRemoveFirstLabel(marcLabelInput: MarcLabelInput) {
    const index = this.firstMarcLabelInputs.findIndex(item => {
      return (
        item.tagGroup === marcLabelInput.tagGroup &&
        item.no === marcLabelInput.no
      )
    })
    this.firstMarcLabelInputs.splice(index, 1)
  }

  onClickAddFirstTag(
    firstLabel: FirstMarcLabelInput,
    marcTagInputData: MarcTagInputData
  ) {
    const index = cloneDeep(firstLabel.tags)
      .reverse()
      .findIndex(item => {
        return item.default.marcTag === marcTagInputData.default.marcTag
      })
    const lastTagIndex = firstLabel.tags.length - (index + 1)

    const tag = firstLabel.tags[lastTagIndex]
    const addTag = cloneDeep(tag)

    const tagSeqKey = `${tag.default.marcTag}-${firstLabel.no}`
    const seq = this.tagSeq.get(tagSeqKey)
    const nextSeq = seq !== undefined ? seq + 1 : 1
    const nextBottomNumber = nextSeq.toString().padStart(4, '0')

    const shortTag = tag.default.tag.substr(0, tag.default.tag.length - 4)
    addTag.default.no = nextBottomNumber
    addTag.default.tag = `${shortTag}${nextBottomNumber}`
    addTag.default.data = ''

    if (addTag.marcNo !== undefined) {
      const shortTag = tag.marcNo?.tag.substr(0, tag.marcNo?.tag.length - 4)
      addTag.marcNo.no = nextBottomNumber
      addTag.marcNo.tag = `${shortTag}${nextBottomNumber}`
      addTag.marcNo.data = ''
    }

    firstLabel.tags.splice(lastTagIndex + 1, 0, addTag)

    this.tagSeq.set(tagSeqKey, nextSeq)
  }

  onClickInputDetail(title: string, tag: MarcTagInput) {
    const name = tag.labelName + ' ' + (tag.repeat ? tag.no : '')

    this.modalTextArea.open({
      value: tag.data,
      title,
      fieldName: name,
      limitLinefeed: true,
      onClickOk: (value: string) => (tag.data = value)
    })
  }

  onClickInputDetailAuthorityName(title: string, tag: MarcTagInputData) {
    this.modalTextArea.open({
      value: tag.authorityName ? tag.authorityName.data : '',
      title,
      fieldName: '表記',
      limitLinefeed: true,
      onClickOk: (value: string) => {
        if (tag && tag.authorityName) {
          tag.authorityName.data = value
          this.setAuthorityText(tag)
        }
      }
    })
  }

  onClickInputDetailAuthorityKana(title: string, tag: MarcTagInputData) {
    this.modalTextArea.open({
      value: tag.authorityKana ? tag.authorityKana.data : '',
      title,
      fieldName: 'カナ',
      limitLinefeed: true,
      onClickOk: (value: string) => {
        if (tag && tag.authorityKana) {
          tag.authorityKana.data = value
          this.setAuthorityText(tag)
        }
      }
    })
  }

  onClickRemoveFirstTag(marcLabelInput: FirstMarcLabelInput, tagIndex: number) {
    marcLabelInput.tags.splice(tagIndex, 1)
  }

  onClickAddSecondLabel(
    firstMarcLabelInput: FirstMarcLabelInput,
    secondMarcLabelInput: MarcLabelInput
  ) {
    let secondLabelIndex
    let secondLabel: MarcLabelInput | undefined
    for (
      secondLabelIndex = firstMarcLabelInput.secondMarcLabels.length - 1;
      secondLabelIndex >= 0;
      secondLabelIndex--
    ) {
      secondLabel = firstMarcLabelInput.secondMarcLabels[secondLabelIndex]

      if (secondLabel.tagGroup === secondMarcLabelInput.tagGroup) {
        break
      }
    }
    if (secondLabel === undefined) return

    const secondLabelSeqKey = `${secondLabel.tagGroup}-${firstMarcLabelInput.no}`
    const seq = this.secondLabelSeq.get(secondLabelSeqKey)
    const nextSeq = seq !== undefined ? seq + 1 : 1
    const nextMiddleNumber = nextSeq.toString().padStart(4, '0')

    let secondMarcLabel: MarcLabel | undefined
    for (let k = 0; k < this.firstMarcLabels.length; k++) {
      const firstMarcLabel = this.firstMarcLabels[k]

      secondMarcLabel = firstMarcLabel.secondMarcLabels.find(item => {
        return item.tagGroup === secondLabel?.tagGroup
      })

      if (secondMarcLabel) {
        break
      }
    }

    if (secondMarcLabel === undefined) return

    const marcLabelItem = this.createSecondLabelInputData(
      secondMarcLabel,
      firstMarcLabelInput.no,
      nextMiddleNumber
    )

    if (marcLabelItem !== undefined) {
      firstMarcLabelInput.secondMarcLabels.splice(
        secondLabelIndex + 1,
        0,
        marcLabelItem
      )
      this.secondLabelSeq.set(secondLabelSeqKey, nextSeq)
    }
  }

  onClickRemoveSecondLabel(
    firstMarcLabelInput: FirstMarcLabelInput,
    secondMarcLabelInput: MarcLabelInput,
    secondIndex: number
  ) {
    const firstLabel = this.firstMarcLabelInputs.find(item => {
      return (
        item.tagGroup === firstMarcLabelInput.tagGroup &&
        item.no === firstMarcLabelInput.no
      )
    })
    if (firstLabel === undefined) return

    firstLabel.secondMarcLabels.splice(secondIndex, 1)
  }

  onClickAddSecondTag(
    firstLabel: FirstMarcLabelInput,
    secondLabel: MarcLabelInput,
    marcTagInputData: MarcTagInputData
  ) {
    let tagIndex
    for (tagIndex = secondLabel.tags.length - 1; tagIndex >= 0; tagIndex--) {
      if (
        secondLabel.tags[tagIndex].default.marcTag ===
        marcTagInputData.default.marcTag
      ) {
        break
      }
    }

    const tag = secondLabel.tags[tagIndex]
    const addTag = cloneDeep(tag)

    const tagSeqKey = `${tag.default.marcTag}-${firstLabel.no}-${secondLabel.no}`
    const seq = this.tagSeq.get(tagSeqKey)
    const nextSeq = seq !== undefined ? seq + 1 : 1
    const nextBottomNumber = nextSeq.toString().padStart(4, '0')

    const shortTag = tag.default.tag.substr(0, tag.default.tag.length - 4)
    addTag.default.no = nextBottomNumber
    addTag.default.tag = `${shortTag}${nextBottomNumber}`
    addTag.default.data = ''

    secondLabel.tags.splice(tagIndex + 1, 0, addTag)

    this.tagSeq.set(tagSeqKey, nextSeq)
  }

  onClickRemoveSecondTag(secondLabel: MarcLabelInput, tagIndex: number) {
    secondLabel.tags.splice(tagIndex, 1)
  }

  calculateTableHeight() {
    this.height = 0

    this.$nextTick(() => {
      this.height = window.innerHeight - 200
    })
  }

  onClickWriteKana() {
    const separateTags: SeparateTag[] = this.getSeparateTags()
    if (separateTags.length === 0) return

    this.fetchSeparateKana(separateTags)
  }

  getSeparateTags(): SeparateTag[] {
    const kanaBibliographies = dataStore.kanaBibliographies
    if (kanaBibliographies.length === 0) return []

    const displayNumberReg = new RegExp(
      '^[0-9A-Z]{2}([0-9n]{4})[0-9A-Z]{2}([0-9n]{4})[0-9A-Z]{2}([0-9n]{4})$'
    )
    const kanaTagReg = new RegExp(
      '^([0-9A-Z]{2})([0-9n]{4})([0-9A-Z]{2})([0-9n]{4})([0-9A-Z]{2})([0-9n]{4})$'
    )

    const separateTags: SeparateTag[] = []

    this.firstMarcLabelInputs.forEach(
      (firstMarcLabelInput: FirstMarcLabelInput) => {
        firstMarcLabelInput.tags.forEach(
          (marcTagInputData: MarcTagInputData) => {
            const targetDisplayMarcTag = kanaBibliographies.find(
              tag => tag.display === marcTagInputData.default.marcTag
            )
            if (targetDisplayMarcTag) {
              const displayNumbers = marcTagInputData.default.tag.match(
                displayNumberReg
              )
              if (displayNumbers === null) {
                return
              }

              const kanaTags = targetDisplayMarcTag.kana.match(kanaTagReg)
              if (kanaTags === null) {
                return
              }

              const kanaTag = `${kanaTags[1]}${displayNumbers[1]}${kanaTags[3]}${displayNumbers[2]}${kanaTags[5]}${kanaTags[6]}`
              const kanaDataItem = firstMarcLabelInput.tags.find(
                (item: MarcTagInputData) => {
                  return kanaTag === item.default.tag
                }
              )

              separateTags.push({
                displayTag: marcTagInputData.default.tag,
                displayMarcTag: marcTagInputData.default.marcTag,
                displayData: marcTagInputData.default.data,
                kanaTag,
                kanaMarcTag: targetDisplayMarcTag.kana,
                kanaData: kanaDataItem ? kanaDataItem.default.data : ''
              })
            }
          }
        )

        firstMarcLabelInput.secondMarcLabels.forEach(
          (secondMarcLabelInput: MarcLabelInput) => {
            secondMarcLabelInput.tags.forEach(
              (marcTagInputData: MarcTagInputData) => {
                const targetDisplayMarcTag = kanaBibliographies.find(
                  tag => tag.display === marcTagInputData.default.marcTag
                )
                if (targetDisplayMarcTag) {
                  const displayNumbers = marcTagInputData.default.tag.match(
                    displayNumberReg
                  )
                  if (displayNumbers === null) {
                    return
                  }

                  const kanaTags = targetDisplayMarcTag.kana.match(kanaTagReg)
                  if (kanaTags === null) {
                    return
                  }

                  const kanaTag = `${kanaTags[1]}${displayNumbers[1]}${kanaTags[3]}${displayNumbers[2]}${kanaTags[5]}${kanaTags[6]}`
                  const kanaDataItem = secondMarcLabelInput.tags.find(
                    (item: MarcTagInputData) => {
                      return kanaTag === item.default.tag
                    }
                  )
                  separateTags.push({
                    displayTag: marcTagInputData.default.tag,
                    displayMarcTag: marcTagInputData.default.marcTag,
                    displayData: marcTagInputData.default.data,
                    kanaTag,
                    kanaMarcTag: targetDisplayMarcTag.kana,
                    kanaData: kanaDataItem ? kanaDataItem.default.data : ''
                  })
                }
              }
            )
          }
        )
      }
    )

    return separateTags
  }

  async fetchSeparateKana(separateTags: SeparateTag[]) {
    const keywords: Keyword[] = []

    separateTags.forEach(item => {
      if (item.displayData !== '' && item.kanaData === '') {
        keywords.push({
          key: item.displayMarcTag,
          tag: item.kanaTag,
          word: item.displayData
        })
      }
    })

    if (keywords.length === 0) return

    const separateKeywords: SeparateKeyword[] = await separateApi.separateKana({
      keywords
    })

    this.mergeSeparateKana(separateKeywords)
  }

  mergeSeparateKana(separateKeywords: SeparateKeyword[]) {
    this.firstMarcLabelInputs.forEach(
      (firstMarcLabelInput: FirstMarcLabelInput) => {
        firstMarcLabelInput.tags.forEach(
          (marcTagInputData: MarcTagInputData) => {
            const item = separateKeywords.find(
              keyword => marcTagInputData.default.tag === keyword.tag
            )
            if (item) {
              marcTagInputData.default.data = item.value
            }
          }
        )

        firstMarcLabelInput.secondMarcLabels.forEach(
          (secondMarcLabelInput: MarcLabelInput) => {
            secondMarcLabelInput.tags.forEach(
              (marcTagInputData: MarcTagInputData) => {
                const item = separateKeywords.find(
                  keyword => marcTagInputData.default.tag === keyword.tag
                )
                if (item) {
                  marcTagInputData.default.data = item.value
                }
              }
            )
          }
        )
      }
    )
  }
}
